import detectApp from '@/utils/detect-app';
import platformMaps from '@/utils/platform-maps';

const wx = require('weixin-js-sdk');

function getPlatformGeneral() {
  return new Promise(resolve => {
    const platforms = platformMaps;
    let platformKey = '';
    if (detectApp.isFromCY()) {
      platformKey = 'app';
      return resolve(platforms[platformKey]);
    }
    if (detectApp.isFromWechat()) {
      wx.miniProgram.getEnv(wxres => {
        console.log(wxres);
        if (wxres.miniprogram) {
          // 微信小程序环境
          const type = sessionStorage.getItem('mini_from');
          if (type === 'healthy_mall') {
            platformKey = 'wxmini_healthy_mall';
          } else {
            platformKey = 'wxmini_main';
          }
          return resolve(platforms[platformKey]);
        }
        platformKey = 'h5_wx';
        return resolve(platforms[platformKey]);
      });
    } else {
      platformKey = 'h5_open';
      return resolve(platforms[platformKey]);
    }
  });
}

export default getPlatformGeneral;
